(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-footer"] && !Shopify.designMode) return;
  try {
    
  // Modale de confirmation newsletter : rendue OUVERTE côté serveur (visible sans
  // JS, fermeture = lien vers canonical_url). Le JS n'intercepte JAMAIS le submit
  // (captcha Shopify intact) — il gère seulement la fermeture sans reload, le focus,
  // ESC et un piège à focus minimal.
  (function () {
    function close(modal) {
      if (!modal || !modal.parentNode) return;
      modal.parentNode.removeChild(modal);
      if (window.history && history.replaceState) {
        try {
          history.replaceState({}, document.title, location.pathname);
        } catch (e) {}
      }
    }

    function init() {
      var modal = document.querySelector('[data-me-nl-modal]');
      if (!modal) return;
      var closeEl = modal.querySelector('.me-nl-modal__close');

      modal.querySelectorAll('[data-me-nl-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          close(modal);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) close(modal);
      });

      // Piège à focus minimal (peu d'éléments : la croix, le lien).
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = modal.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0],
          last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      if (closeEl) closeEl.focus();
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-home-shelf"] && !Shopify.designMode) return;
  try {
    
  class MeShelf extends HTMLElement {
    connectedCallback() {
      this._down = false;
      this._moved = false;
      this._onDown = this._onDown.bind(this);
      this._onMove = this._onMove.bind(this);
      this._onUp = this._onUp.bind(this);
      this._onClick = this._onClick.bind(this);
      this.addEventListener('mousedown', this._onDown);
      this.addEventListener('mousemove', this._onMove);
      this.addEventListener('mouseleave', this._onUp);
      this.addEventListener('click', this._onClick, true);
      window.addEventListener('mouseup', this._onUp);
    }

    disconnectedCallback() {
      window.removeEventListener('mouseup', this._onUp);
    }

    _onDown(e) {
      this._down = true;
      this._moved = false;
      this._x0 = e.pageX;
      this._sl0 = this.scrollLeft;
      this.classList.add('is-dragging');
    }

    _onMove(e) {
      if (!this._down) return;
      const dx = e.pageX - this._x0;
      if (Math.abs(dx) > 4) this._moved = true;
      e.preventDefault();
      this.scrollLeft = this._sl0 - dx * 1.4;
    }

    _onUp() {
      this._down = false;
      this.classList.remove('is-dragging');
    }

    _onClick(e) {
      if (this._moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }

  if (!customElements.get('me-shelf')) {
    customElements.define('me-shelf', MeShelf);
  }

  } catch(e) { console.error(e); }
})();
})();
